import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

let messages = {
  "en": {
    welcomeMsg: "Welcome",
    bestMachine: "Best machine",
    bestActivity: "Best activity",
    totalProgress: "Total progress",
    average: "Average",
    headerMainMsg: "You have already trained ",
    times: "times",
    getraind: "",
    year: "year",
    years: "years",
    and: "and",
    month: "month",
    months: "months",
    headerMachineMsg:
      "Here you can see improvements to the machines you train on weekly",
    headerActivityMsg:
      "Here you can see improvement in activities that you perform every day",
    totalSessions: "Number of times performed",
    bestPerformance: "Best performance",
    date: "Date",
    score: "Score",
    weight: "Weight",
    duration: "Duration",
    unknown: "unknown",
    mainErrorMsg: "something went wrong",
    unknownEmailMsg:
      "Unknown email. Give your email address with which you are logged in at Virtuagym to your personal trainer",
    reportErrorMsg:
      "You still do not have enough sessions to see your progress",
    tillen: "Lifting",
    duwen: "Pushing",
    zitten: "Sitting",
    traplopen: "Walking stairs",
    staan: "Standing",
    last: "Last",
    sessions: "sessions",
    all: "All",
    ambition: "ambition",
    question_1_1: "Who is the contact person within fit20?",
    answer_1_1: "It is easiest to contact Rob Reuters via mail rob@fit20.nl",
    question_2_1: "What is fit20?",
    answer_2_1:
      "fit20 is an innovative and unique fitness method. At fit20 you train 20 minutes once a week and always under the guidance of your fit20 Personal Trainer. You train by appointment and you don not have to change or shower. The results are amazing. You can easily keep fit20 long.",
    question_2_2: "How big is fit20?",
    answer_2_2:
      "fit20 is a successful Dutch franchise formula, which is already active in 7 other countries. There are now more than 140 fit20 studios. fit20 is growing strongly.",
    question_2_3: "What are fit20's USPs?",
    answer_2_3:
      '1. Time efficiency: our core promise is "fit in 20 minutes a week". Our training is suitable for everyone, including the busiest people.The training becomes "just" a regular part of your working week.\n 2. Personal Trainer: intensive personal guidance allows a much broader target group to participate successfully, including the less sporty people.Members train alone or with a duo partner.\n 3. Measurably effective: For yourself: you feel much stronger, fitter and more energetic! For companies: increasing vitality, reducing absenteeism, improving productivity, high compliance, high satisfaction, reducing complaints.\n 4. Optimal privacy: you train alone or with your training partner in a studio without others.\n5.By appointment: Your training is planned together with you.Your personal trainer is waiting for you.We are the stick behind the door.You can easily keep fit20 full.',
    question_3_1: "What is the IT ambition of fit20?",
    answer_3_1:
      "fit20 is a global market leader in the field of High Intensity Training and is distinguished by the innovative way of training and customer experience. This means that our IT ambitions are also very high (Hi Tech, Human Touch).",
    question_3_2:
      "How does the Mobile Solutions project fit within the fit20 themes?",
    answer_3_2:
      "The enduser app that Windesheim students have successfully developed is integrated as an app-in-app into the fit20 enduser environment. It meets our Customer Delight theme well.",
    question_3_3: "How is the project integrated within our other IT projects?",
    answer_3_3:
      "The app developed by Windesheim retrieves (naturally secure) the training results of a member from the central Google Cloud Datastore and shows them to the fit20 member in a very user-friendly way.",
    question_3_4: "What are the long-term IT themes that fit20 uses?",
    answer_3_4: `There are three main areas:\n
      1) the fit20 customer with the Customer Delight theme;\n
      2) the fit20 personal trainer with the Job Excitement theme;\n
      3) the fit20 organization with the Lean & Mean theme.`,
    question_3_5:
      "What functionalities does the Windesheim Mobile Solutions app offer?",
    answer_3_5:
      "The client receives interactive insight into his fit20 training results on his mobile through the pp. This allows him to see trends, gain insight into his progress and view his best results. The customer can then enrich this data by adding personal notes.",
    motivationMsg0: "Good job! Keep it up",
    motivationMsg1: "fit20 provides your weekly health incentive",
    motivationMsg2:
      "The Supercardio effect of fit20 continues for an hour and a half after the training. Also on the couch",
    motivationMsg3:
      "The most important biomarkers of your health are muscle mass and muscle strength",
    motivationMsg4:
      "The best results are in the last seconds of your training.",
    motivationMsg5: "Already a member? Keeping up is progress",
    motivationMsg6:
      "The pillars of your fit20 training: sleep, recovery, nutrition and relaxation",
    motivationMsg7:
      "The most important factor for your training results is persistence. fit20 for life",
    motivationMsg8:
      "It is not about how heavy the weight is, but how heavy your effort is (intensity of effort)",
    motivationMsg9: `You've regained your weekly health boost!`,
    motivationMsg10:
      "Your muscles are your largest endocrine (= communicating) organ",
    motivationMsg11:
      "fit20 has a very good effect on all biomarkers for your health",
    motivationMsg12:
      "Biomarkers for your health: muscle mass, muscle strength, bone density, body composition, blood fat content, blood pressure",
    motivationMsg13:
      "Biomarkers for your health: blood glucose regulation, aerobic capacity, gene expression, brain factors",
    motivationMsg14:
      "You have improved everything in your entire body through your fit20 training!",
    motivationMsg15: "Growing old healthy and fit? fit20 for life!",
    L0000: "English US",
    login: "Login",
    logout: "Log out",
    not_member_yet: "Not yet a member?",
    experience_fit20: "Experience fit20",
    experience_fit20_free: "Experience fit20 for free!",
    in_your_neighbourhood: "in your neighbourhood!",
    request_exp_training: "In which country do you want to request an introductory training?",
    welcome: "Welcome",
    at_your_fit20: "at your fit20",
    enter_info_to_login: "Enter your information to log in",
    enter_email_address: "Enter your email address",
    enter_password: "Enter your password",
    remember_me: "Remember me",
    forget_password: "Forgot your password?",
    dont_have_account_yet: "Don't have an account yet?",
    register_now: "Register now",
    cant_login: "Can't log in?",
    ask_trainer_for_hulp: "Ask your fit20 trainer for help.",
    go_to_login: "Go to login",
    enter_email_address_known_to_trainer: "Enter your email address known to your fit20 trainer.",
    receive_confirm_email_to_reset_password: "You will receive a confirmation email with a link to reset your password.",
    send: "send",
    send_confirm_email_not_possible: "Is sending confirmation email not possible?",
    reset_password_email_sent: "An email has been sent with a link to reset your password.",
    see_you_soon: "See you soon!",
    account_activated: "Account activated?",
    enter_info_to_register: "Enter your information to register.",
    create_new_password: "Create a new password",
    re_enter_password: "Re-enter this password",
    password_does_not_match: "Your password does not match.",
    register: "Register",
    cant_register: "Can't register?",
    already_have_account: "Do you already have an account?",
    trainer_invite_you_to_register: "Your trainer has invited you to sign up with:",
    change_password_for: "Change the password for:",
    confirm: "confirm",
    cant_reset_password: "Can't reset password?",
    password_reset_successful: "Password reset successful!",
    you_can_login_again: "You can log in again",
    search: "Search",
    my_results: "My results",
    fit20_news: "fit20 news",
    my_studio: "My studio",
    my_investment: "My investment",
    my_appointments: "My appointments",
    change_password: "Change password",
    log_out: "Log out",
    change_the_password: "Change the password",
    enter_current_password: "Enter current password",
    cant_change_password: "Can't change password?",
    back_to_settings: "Back to settings",
    password_changed_successfully: "Password changed successfully!",
    back: "Back",
    user_not_authenticated: "User not authenticated.",
    enter_valid_data: "Please enter valid data.",
    something_went_wrong_try_again: "Something went wrong!\nTry again.",
    incorrect_password: "Incorrect password! Try again.",
    unknown_email_try_to_register: "This email address is not known to us. Try to register.",
    unknown_email_ask_trainer_for_hulp: "This email address is not known to us. Ask your trainer for help.",
    request_not_authenticated: "This email address already exists. Try to login.",
    invalid_or_expired_link: "This link is invalid or expired.",
    register_successful_direct_login: "You have been successfully registered and can log in directly.",
    register_successful_confirm_email: "You have been registered successfully. Please check your inbox to confirm your email.",
    this_password_weak: "This password is weak",
    this_password_ok: "This password is OK!",
    this_password_strong: "This password is strong!",
    create_password_with_at_least_6_characters: "Think of a password with at least 6 characters.",
    current_password_new_password_same: "Current password and new password must not be the same.",
    reload: "reload",
    coming_soon: "Coming soon",
    select_studio: "Select a studio",
    back_to_homepage: "Back to homepage",
    ok: "OK",
    change_profile_img: "Change profile photo",
    file_name: "File name",
    file_size: "File size",
    select_image: "Select an image",
    image_size_less_than_2MB: "Image size should be less than 2MB",
    cancel: "Cancel",
    profile_image_changed_successfully: "Your profile picture has been successfully changed",
    image_size_larger_2MB: "Image size is larger than 2MB",
    image_format_invalid: "Image format is invalid",
    authentication_failed: "Authentication failed",
    account_already_confirmed_try_to_login: "This account is already confirmed! Try to log in.",
    confirm_email_resent_successfully: "A new confirmation email has been sent. Please check your mailbox.",
    expired_session_try_to_login_again: "Expired session!\nTry to log in again",
    account_not_confirmed_yet_try_to_confirm: "This account has not been confirmed yet! Try to confirm your account",
    token_invalid: "Token is invalid",
    token_expired: "Token is expired",
    no_studios_found: "No studios found",
    no_news_found: "No news found",
    no_results_found: "No results found",
    invalid_img_data: "Invalid image data",
    invalid_action_type: "Invalid action type",
    save: "Save",
    delete_account: "Delete Account",
    you_sure_delete_appointment: "Are you sure you want to delete this appointment?",
    you_sure_reschedule_appointment: "Are you sure you want to reschedule this appointment?",
    delete: "Delete",
    reschedule: "Reschedule",
    if_you_delete_account: "If you delete this account:",
    no_longer_login_fit20_app: "You will no longer be able to log in to the fit20 app.",
    confirm_delete_accout_typing: "Confirm you want to delete this account by typing:",
    type_delete: "Type DELETE",
    enter: 'Enter',
    to_confirm: "to confirm",
    account_deleted_sccessfully: "Account has deleted successfully",
    select_app_language: "Select language",
    change_language: "Change language",
    redirect_failed: "Redirect failed",
    unexpected_error: "Unexpected Error",
    action_failed: "Action failed",
    your_trainings: "Your trainings",
    upcoming_trainings: "Upcoming trainings",
    look_ahead_trainings: "You can look ahead to up to {count} trainings",
    no_trainings_to_display: "There are no trainings to display",
    try_again_ask_trainer_for_help: "Try again or ask your trainer for help",
    your_training: "Your training",
    select_time: "Select time",
    training_session_reschedule_limit_with_count: 'You can reschedule your fixed training session up to {count} times. After that, you can only cancel.',
    time_slot_unavailable_retry: 'Unfortunately, this time slot is already taken.\nPlease try again.',
    not_available: 'Not available',
    confirm_cancellation: 'Confirm cancellation',
    cancel_training_with_reschedule_option: 'You are canceling the training.\nAs long as the date has not yet passed, you can reschedule the training.',
    not_saved: 'Niet opgeslagen',
    continue_without_save: 'Warning: Do you want to proceed without saving?',
    unfortunately: 'Unfortunately',
    success: 'Success',
    training_canceled_successfully: 'The training has been successfully canceled.',
    cancel_training_for: 'You can cancel this training for:',
    reschedule_training: 'Reschedule this training',
    week: 'Week',
    no_times_available: 'No times are available',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    max_reschedule_attempts_reached: 'You have already reached the maximum number of attempts to reschedule this training session.',
    canceled_training_cannot_be_rescheduled: 'This canceled training session cannot be rescheduled.',
    confirm_reschedule: 'Confirm rescheduling',
    confirm_training_reschedule: 'Do you want to reschedule the training?',
    duo_confirm_training_reschedule: 'Your DUO partner is currently not scheduled to attend. By rescheduling this time slot, you can reactivate it for both of you. Whatever you choose, both of you will receive a confirmation by email. \nWho will attend the new time slot?',
    training_rescheduled_success: 'The training has been successfully rescheduled.',
    reason_for_cancellation: 'Reason for cancellation',
    other_commitment: 'Other commitment',
    sick: 'Sick',
    injury: 'Injury',
    vacation: 'Vacation',
    other_reason: 'Other reason',
    message: 'Message',
    type_message_here: 'Type a message here...',
    select_cancellation_reason: 'Select a reason',
    cancellation_reason: 'Reason for cancellation',
    no_appointments_to_display: 'There are no appointments to display.',
    try_again: 'Try again',
    what_is_the_reason: 'What is the reason?',
    oops_try_again_or_contact_trainer: 'Oops, something went wrong. Try again or contact your trainer.',
    email_being_confirmed: 'Email is being confirmed',
    account_activated_success: 'Your account has been successfully activated',
    account_already_activated: 'Your account has already been activated',
    you_can_now_log_in: 'You can now log in',
    email_verification_failed: 'Your email verification has failed',
    not_successful_yet: 'Not successful yet?',
    send_confirmation_email: 'Send confirmation email',
    confirmation_email_sent: 'Confirmation email has been sent',
    activate_account_via_confirmation_email: 'Activate your account via the confirmation email',
    registration_successful: 'Registration was successful',
    account_not_confirmed: 'Your account has not been confirmed yet',
    confirmation_email_not_received: "Didn't receive a confirmation email?",
    application_under_construction: 'This application is currently under construction',
    duo_partner_confirmation_notice: 'Please note that this also applies to your DUO partner. You will both receive a confirmation email.',
    email_already_registered_forgot_password: 'This email address is already registered. Select Forgot password',
    session_canceled_too_late_contact_trainer: 'This session was canceled too late, please contact your trainer.',
    session_rescheduled_too_late_contact_trainer: 'This session was rescheduled too late, please contact your trainer.',
    no_training_possible: 'No training possible',
    reschedule_not_possible: 'This appointment will be cancelled. Rescheduling is not possible in this case.',
    user_deleted_successfully: "Your fit20 account has been successfully deleted.",
    Sunday: "So",
    Monday: "Mo",
    Tuesday: "Tu",
    Wednesday: "We",
    Thursday: "Th",
    Friday: "Fr",
    Saturday: "Sa",
    January: "Jan",
    February: "Feb",
    March: "Mar",
    April: "Apr",
    May: "May",
    June: "Jun",
    July: "Jul",
    August: "Aug",
    September: "Sep",
    October: "Oct",
    November: "Nov",
    December: "Dec",
    time_for_update: "It’s time for an update!",
    new_version_available: "New version available",
    update_message: "You’re using an older version of the app. Please open the Google Play Store or App Store, search for <span class='app-name'>{appName}</span>, and install the latest update.",
    update_message_notice: "Starting with the next version, you’ll be able to update directly from inside the app.",
    update: "Update",
    training_session_already_rescheduled_refresh_and_try_again: "This training session has already been rescheduled, please refresh the page and try again.",
    confirm_reactivation: "Confirm reactivation",
    confirm_reactivate_cancelled_time_slot: "Are you sure you want to reactivate this time slot?",
    reactivate: "Reactivate",
  },


  nl: {
    welcomeMsg: "Welkom",
    bestMachine: "Beste machine",
    bestActivity: "Beste activiteit",
    totalProgress: "Totale voortgang",
    average: "Gemiddeld",
    headerMainMsg: "Je hebt al ",
    times: "keer",
    getraind: "getraind",
    year: "jaar",
    years: "jaar",
    and: "en",
    month: "maand",
    months: "maanden",
    headerMachineMsg:
      "Hier zijn je verbeteringen te zien van de machines waar je wekelijks op traint",
    headerActivityMsg:
      "Hier is je verbetering te zien bij activiteiten die je dagelijks uitvoert",
    totalSessions: "Aantal keren uitgevoerd",
    bestPerformance: "Beste prestaties",
    date: "Datum",
    score: "Score",
    weight: "Gewicht",
    duration: "Looptijd",
    unknown: "onbekend",
    mainErrorMsg: "iets ging fout",
    unknownEmailMsg:
      "Onbekend email. Geef je email adres waar je mee je bent ingelogd bij Virtuagym aan je personal trainer",
    reportErrorMsg:
      "Je hebt nog steeds niet genoeg sessies om je voortgang te zien",
    tillen: "Tillen",
    duwen: "Duwen",
    zitten: "Zitten",
    traplopen: "Traplopen",
    staan: "Staan",
    last: "Laatste",
    sessions: "sessies",
    all: "Alle",
    ambition: "ambitie",
    question_1_1: "Wie is het contactpersoon binnen fit20?",
    answer_1_1:
      "Je kunt het makkelijkst contact opnemen met Rob Reuters via mail rob@fit20.nl",
    question_2_1: "Wat is fit20?",
    answer_2_1:
      "fit20 is een innovatieve en unieke fitness methode. Bij fit20 train je één keer per week 20 minuten en altijd onder begeleiding van jouw fit20 Personal Trainer. Je traint op afspraak en je hoeft niet om te kleden of te douchen. De resultaten zijn verbluffend. Je kunt fit20 makkelijk lang volhouden.",
    question_2_2: "Hoe groot is fit20?",
    answer_2_2:
      "fit20 is een succesvolle Nederlandse franchiseformule, die inmiddels al in 7 andere landen actief is. Er zijn inmiddels meer dan 140 fit20 studio’s. fit20 groeit sterk.",
    question_2_3: "Wat zijn de USP’s van fit20?",
    answer_2_3:
      '1. Tijdsefficiënt: onze kernbelofte is "fit in 20 minuten per week". Onze training is inpasbaar voor iedereen, ook de drukste personen. De training wordt "gewoon" een vast onderdeel van je werkweek.\n2. Personal Trainer: door de intensieve persoonlijke begeleiding kan een veel bredere doelgroep succesvol meedoen, ook de minder sportieve personen. Leden trainen alleen of met een duo-partner.\n3. Meetbaar effectief: Voor jezelf: je voelt je veel sterker, fitter en  energieker! Voor bedrijven: verhoging vitaliteit, reductie verzuim, verbetering productiviteit, hoge compliance, hoge tevredenheid, vermindering klachten.\n4. Optimale privacy: je traint alleen of met je trainingspartner in een studio zonder anderen. \n5. Op afspraak: Jouw training wordt samen met je ingepland. Je personal trainer wacht op je. Wij zijn de stok achter de deur. Je houdt fit20 makkelijk lang vol.',
    question_3_1: "Wat is de ICT ambitie van fit20?",
    answer_3_1:
      "fit20 is global market-leader op het gebied van High Intensity Training en onderscheidt zich door de innovatieve manier van trainen en klantervaring. Dit betekent dat onze ICT ambities ook zeer hoog liggen (Hi Tech, Human Touch).",
    question_3_2:
      "Hoe past het Mobile Solutions project binnen de fit20 thema’s?",
    answer_3_2:
      "De enduser app die de Windesheim studenten met veel succes hebben ontwikkeld, wordt als een app-in-app geïntegreerd in de fit20 enduser omgeving. Het voldoet goed aan ons thema Customer Delight.",
    question_3_3:
      "Hoe is het project geïntegreerd binnen onze andere ICT projecten?",
    answer_3_3:
      "De door Windesheim ontwikkelde app haalt (natuurlijk secure) de trainingsresultaten van een lid op uit de centrale Google Cloud Datastore en toont deze op een zeer gebruikersvriendelijke manier aan het fit20 lid.",
    question_3_4: "Wat zijn de lange termijn ICT thema’s waarop fit20 inzet?",
    answer_3_4: `Er zijn drie hoofdgebieden:\n
    1) de fit20 klant met het thema Customer Delight;\n
    2) de fit20 personal trainer met het thema Job Excitement;\n
    3) de fit20 organisatie met het thema Lean & Mean.`,
    question_3_5:
      "Welke functionaliteiten biedt de Windesheim Mobile Solutions app?",
    answer_3_5:
      "De klant krijgt middels de pp interactieve inzage in zijn fit20 trainingsresultaten op zijn mobiel. Hierdoor kan hij trends zien, zijn voortgang inzichtelijk krijgen en zijn beste resultaten bekijken. Deze gegevens kan de klant vervolgens verrijken middels het toevoegen van persoonlijke notities.",
    motivationMsg0: "Goed bezig! Houd dit zo vast",
    motivationMsg1: `fit20 zorgt voor je wekelijkse gezondheidsprikkel`,
    motivationMsg2: `Het Supercardio effect van fit20 gaat na de training nog anderhalf uur door. Ook op de bank`,
    motivationMsg3: `De belangrijkste biomarkers van je gezondheid zijn spiermassa en spierkracht`,
    motivationMsg4: `In de laatste seconden van je training zit het beste resultaat`,
    motivationMsg5: `Al langer lid? Op niveau blijven is vooruitgang`,
    motivationMsg6: `Dé pijlers onder je fit20 training: slaap, herstel, voeding en ontspanning`,
    motivationMsg7: `De allerbelangrijkste factor voor je trainingsresultaat is volhouden. fit20 for life`,
    motivationMsg8: `Het gaat niet om hoe zwaar het gewicht is maar om hoe zwaar je inspanning is (intensity of effort)`,
    motivationMsg9: `Je hebt je wekelijkse gezondheidsprikkel weer binnen`,
    motivationMsg10: `Je spieren zijn je grootste endocriene (=communicerende) orgaan`,
    motivationMsg11: `fit20 heeft een zeer goed effect op alle biomarkers voor je gezondheid`,
    motivationMsg12: `Biomarkers voor je gezondheid: spiermassa, spierkracht, botdichtheid, lichaamsopbouw, vetgehalte bloed, bloeddruk.`,
    motivationMsg13: `Biomarkers voor je gezondheid: bloedglucoseregulering, aeroob vermogen, gen expressie, hersenfactoren.`,
    motivationMsg14: `Je hebt door je fit20 training weer alles in je hele lichaam verbeterd!`,
    motivationMsg15: `Gezond en fit oud worden? fit20 for life!`,
    L0000: "Nederlands NL",
    login: "Login",
    logout: "Uitloggen",
    not_member_yet: "Nog geen lid?",
    experience_fit20: "Ervaar fit20",
    experience_fit20_free: "Ervaar fit20 gratis!",
    in_your_neighbourhood: "bij jou in de buurt!",
    request_exp_training: "In welk land wil je een kennismakingstraining aanvragen?",
    welcome: "Welkom",
    at_your_fit20: "bij jouw fit20",
    enter_info_to_login: "Vul je gegevens in om in te loggen",
    enter_email_address: "Vul je emailadres in",
    enter_password: "Vul je wachtwoord in",
    remember_me: "Onthoud mij",
    forget_password: "Wachtwoord vergeten?",
    dont_have_account_yet: "Nog geen account?",
    register_now: "Registreer nu",
    cant_login: "Lukt het inloggen niet?",
    ask_trainer_for_hulp: "Vraag hulp bij je fit20 trainer.",
    go_to_login: "Ga naar inlog",
    enter_email_address_known_to_trainer: "Vul je emailadres in dat bij je fit20 trainer bekend is.",
    receive_confirm_email_to_reset_password: "Je ontvangt een bevestigingsmail met een link om je wachtwoord te resetten.",
    send: "verstuur",
    send_confirm_email_not_possible: "Is het verzenden van de bevestigingsmail niet mogelijk?",
    reset_password_email_sent: "Er is een e-mail verstuurd met daarin een link om je wachtwoord te resetten.",
    see_you_soon: "Tot snel!",
    account_activated: "Account geactiveerd?",
    enter_info_to_register: "Vul je gegevens in om te registreren.",
    create_new_password: "Bedenk nieuw wachtwoord",
    re_enter_password: "Herhaal dit wachtwoord",
    password_does_not_match: "Je wachtwoord komt niet overeen.",
    register: "Register",
    cant_register: "Lukt het registreren niet?",
    already_have_account: "Heb je al een account?",
    trainer_invite_you_to_register: "Jouw trainer heeft je uitgenodigd om aan te melden met:",
    change_password_for: "Verander het wachtwoord voor:",
    confirm: "bevestig",
    cant_reset_password: "Lukt het wachtwoord resetten niet?",
    password_reset_successful: "Wachtwoord resetten is gelukt!",
    you_can_login_again: "Je kunt opnieuw inloggen",
    search: "Zoeken",
    my_results: "Mijn resultaten",
    fit20_news: "fit20 nieuws",
    my_studio: "Mijn studio",
    my_investment: "Mijn investering",
    my_appointments: "Mijn afspraken",
    change_password: "Wachtwoord wijzigen",
    log_out: "Uitloggen",
    change_the_password: "Verander het wachtwoord",
    enter_current_password: "Voer huidig wachtwoord in",
    cant_change_password: "Lukt het wachtwoord wijzigen niet?",
    back_to_settings: "Terug naar instellingen",
    password_changed_successfully: "Wachtwoord veranderen is gelukt!",
    back: "Terug",
    user_not_authenticated: "Gebruiker niet geauthenticeerd.",
    enter_valid_data: "Voer geldige gegevens in.",
    something_went_wrong_try_again: "Er is iets misgegaan!\nProbeer het opnieuw.",
    incorrect_password: "Onjuist wachtwoord! Probeer het opnieuw.",
    unknown_email_try_to_register: "Dit e-mailadres is niet bij ons bekend. Probeer je te registreren.",
    unknown_email_ask_trainer_for_hulp: "Dit e-mailadres is niet bij ons bekend. Vraag je trainer om hulp.",
    request_not_authenticated: "Dit e-mailadres bestaat al. Probeer in te loggen.",
    invalid_or_expired_link: "Deze link is ongeldig of verlopen.",
    register_successful_direct_login: "Je bent succesvol geregistreerd en kunt direct inloggen.",
    register_successful_confirm_email: "Je bent succesvol geregistreerd. Controleer je inbox om je e-mail te bevestigen.",
    this_password_weak: "Dit wachtwoord is zwak",
    this_password_ok: "Dit wachtwoord is oké!",
    this_password_strong: "Dit wachtwoord is sterk!",
    create_password_with_at_least_6_characters: "Bedenk een wachtwoord met minimaal 6 karakters.",
    current_password_new_password_same: "Het huidige wachtwoord en het nieuwe wachtwoord mogen niet hetzelfde zijn.",
    reload: "opnieuw laden",
    coming_soon: "Binnenkort beschikbaar",
    select_studio: "Selecteer een studio",
    back_to_homepage: "Terug naar de startpagina",
    ok: "OK",
    change_profile_img: "Profielfoto wijzigen",
    file_name: "Bestandsnaam",
    file_size: "Bestandsgrootte",
    select_image: "Selecteer een afbeelding",
    image_size_less_than_2MB: "De afbeeldingsgrootte moet minder dan 2 MB zijn",
    cancel: "Afzeggen",
    profile_image_changed_successfully: "Je profielfoto is succesvol gewijzigd",
    image_size_larger_2MB: "De afbeeldingsgrootte is groter dan 2 MB",
    image_format_invalid: "Het afbeeldingsformaat is ongeldig",
    authentication_failed: "Authenticatie mislukt",
    account_already_confirmed_try_to_login: "Dit account is al bevestigd! Probeer in te loggen.",
    confirm_email_resent_successfully: "Er is een nieuwe bevestigingsmail verzonden. Controleer je mailbox.",
    expired_session_try_to_login_again: "Sessie verlopen!\nProbeer opnieuw in te loggen",
    account_not_confirmed_yet_try_to_confirm: "Dit account is nog niet bevestigd! Probeer je account te bevestigen",
    token_invalid: "Token is ongeldig",
    token_expired: "Het token is verlopen",
    no_studios_found: "Geen studios gevonden",
    no_news_found: "Geen nieuws gevonden",
    no_results_found: "Geen resultaten gevonden",
    invalid_img_data: "Ongeldige afbeeldingsgegevens",
    invalid_action_type: "Ongeldig actietype",
    save: "Opslaan",
    delete_account: "Account verwijderen",
    you_sure_delete_appointment: "Weet je zeker dat je deze afspraak wilt verwijderen?",
    you_sure_reschedule_appointment: "Weet je zeker dat je deze afspraak wilt verplaatsen?",
    delete: "Verwijderen",
    reschedule: "Verzetten",
    if_you_delete_account: "Als je dit account verwijdert:",
    no_longer_login_fit20_app: "Je kan niet meer inloggen op de fit20 App.",
    confirm_delete_accout_typing: "Bevestig dat je dit account wilt verwijderen door te typen:",
    type_delete: "Typ VERWIJDEREN",
    enter: 'Voer',
    to_confirm: "in om te bevestigen",
    account_deleted_sccessfully: "Account is succesvol verwijderd",
    select_app_language: "Selecteer taal",
    change_language: "Taal wijzigen",
    redirect_failed: "Omleiding mislukt",
    unexpected_error: "Onverwachte fout",
    action_failed: "Actie mislukt",
    your_trainings: "Jouw trainingen",
    upcoming_trainings: "Komende trainingen",
    look_ahead_trainings: "Je kan maximaal {count} trainingen vooruit bekijken",
    no_trainings_to_display: "Er zijn geen trainingen om weer te geven",
    try_again_ask_trainer_for_help: "Probeer het opnieuw of vraag je trainer om hulp",
    your_training: "Jouw training",
    select_time: "Selecteer een tijd",
    training_session_reschedule_limit_with_count: 'Jouw vaste trainingsmoment kan je tot {count} keer toe verzetten. Hierna kan je alleen nog afzeggen.',
    time_slot_unavailable_retry: 'Inmiddels is helaas deze tijd al vergeven.\nProbeer het opnieuw.',
    not_available: 'Niet beschikbaar',
    confirm_cancellation: 'Afzeggen bevestigen',
    cancel_training_with_reschedule_option: 'Hierbij zeg je de training af.\nZolang de datum nog niet verstreken is, kan je de training opnieuw plannen.',
    not_saved: 'Niet opgeslagen',
    continue_without_save: 'Let op: Wil je doorgaan zonder op te slaan?',
    unfortunately: 'Helaas',
    success: 'Succes',
    training_canceled_successfully: 'De training is succesvol afgezegd.',
    cancel_training_for: 'Je kan deze training afzeggen voor:',
    reschedule_training: 'Deze training verzetten',
    week: 'Week',
    no_times_available: 'Er zijn geen tijden beschikbaar',
    morning: 'Ochtend',
    afternoon: 'Middag',
    evening: 'AYou have already reached the maximum number of attempts to reschedule this training session.',
    max_reschedule_attempts_reached: 'Je hebt het maximale aantal pogingen om deze trainingsmoment opnieuw in te plannen al bereikt.',
    canceled_training_cannot_be_rescheduled: 'Deze afgezegde trainingsmoment kan niet worden verplaatst.',
    confirm_reschedule: 'Verzetten bevestigen',
    confirm_training_reschedule: 'Wil je de training verzetten?',
    duo_confirm_training_reschedule: 'Je DUO-partner staat momenteel afgemeld. Door dit tijdstip te verplaatsen, kun je het voor jullie beiden heractiveren. Wat je ook kiest, jullie ontvangen hiervan een bevestiging per e-mail. \nWie komen op het nieuwe tijdstip?',
    training_rescheduled_success: 'De training is succesvol verzet.',
    reason_for_cancellation: 'Reden voor afzeggen',
    other_commitment: 'Andere verplichting',
    sick: 'Ziek',
    injury: 'Blessure',
    vacation: 'Vakantie',
    other_reason: 'Andere reden',
    message: 'Bericht',
    type_message_here: 'Typ hier een bericht in...',
    select_cancellation_reason: 'Selecteer een reden',
    cancellation_reason: 'Reden voor afzeggen',
    no_appointments_to_display: 'Er zijn geen afspraken om weer te geven.',
    try_again: 'Probeer het opnieuw',
    what_is_the_reason: 'Wat is de reden?',
    oops_try_again_or_contact_trainer: 'Oeps, er is iets mis gegaan. Probeer het opnieuw of neem contact op met je trainer.',
    email_being_confirmed: 'E-mail wordt bevestigd',
    account_activated_success: 'Je account is succesvol geactiveerd',
    account_already_activated: 'Je account is al geactiveerd',
    you_can_now_log_in: 'Je kunt nu inloggen',
    email_verification_failed: 'Je e-mailverificatie is mislukt',
    not_successful_yet: 'Nog niet gelukt?',
    send_confirmation_email: 'Bevestigingsmail sturen',
    confirmation_email_sent: 'Bevestigingsmail is verzonden',
    activate_account_via_confirmation_email: 'Activeer je account via de Bevestigingsmail',
    registration_successful: 'Het registreren is gelukt',
    account_not_confirmed: 'Je account is nog niet bevestigd',
    confirmation_email_not_received: 'Geen bevestigingsmail ontvangen?',
    application_under_construction: 'Deze applicatie is momenteel in aanbouw',
    duo_partner_confirmation_notice: 'Let op, dit geldt dan ook voor jouw DUO-partner. Jullie krijgen beiden een bevestigingsmail.',
    email_already_registered_forgot_password: 'Dit e-mailadres is al geregistreerd. Kies Wachtwoord vergeten',
    session_canceled_too_late_contact_trainer: 'Deze sessie is te laat afgezegd, neem contact op met je Trainer.',
    session_rescheduled_too_late_contact_trainer: 'Deze sessie is te laat verzet, neem contact op met je Trainer.',
    no_training_possible: 'Geen training mogelijk',
    reschedule_not_possible: 'Deze afspraak vervalt. Verplaatsen is in dit geval niet mogelijk.',
    user_deleted_successfully: "Je fit20-account is succesvol verwijderd.",
    Sunday: "Zo",
    Monday: "Ma",
    Tuesday: "Di",
    Wednesday: "Wo",
    Thursday: "Do",
    Friday: "Vr",
    Saturday: "Za",
    January: "jan",
    February: "feb",
    March: "mrt",
    April: "apr",
    May: "mei",
    June: "jun",
    July: "jul",
    August: "aug",
    September: "sep",
    October: "okt",
    November: "nov",
    December: "dec",
    time_for_update: "Het is tijd voor een update!",
    new_version_available: "Nieuwe versie beschikbaar",
    update_message: "Je gebruikt een verouderde versie van de app. Open de Google Play Store of App Store, zoek op <span class='app-name'>{appName}</span> en installeer de nieuwste update.",
    update_message_notice: "Vanaf de volgende versie kun je direct vanuit de app updaten.",
    update: "Bijwerken",
    training_session_already_rescheduled_refresh_and_try_again: "Deze trainingssessie is al verzet, ververs de pagina en probeer het opnieuw.",
    confirm_reactivation: "Heractivatie bevestigen",
    confirm_reactivate_cancelled_time_slot: "Weet je zeker dat je dit tijdstip wil heractiveren?",
    reactivate: "Heractiveren",
  },

  fr: {
    welcomeMsg: "Bienvenue",
    bestMachine: "Meilleure machine",
    bestActivity: "Meilleure activité",
    totalProgress: "Progrès total",
    average: "Moyenne",
    headerMainMsg: "Vous avez déjà formé ",
    times: "fois",
    getraind: "",
    year: "année",
    years: "ans",
    and: "et",
    month: "mois",
    months: "mois",
    headerMachineMsg:
      "Ici, vous pouvez voir des améliorations aux machines que vous entraînez chaque semaine",
    headerActivityMsg:
      "Ici, vous pouvez voir l amélioration des activités que vous effectuez tous les jours",
    totalSessions: "Nombre de fois exécutées",
    bestPerformance: "Meilleure performance",
    date: "Date",
    score: "But",
    weight: "Poids",
    duration: "Durée",
    unknown: "inconnue",
    mainErrorMsg: "quelque chose a mal tourné",
    unknownEmailMsg:
      "Email inconnu. Donnez votre adresse e-mail avec laquelle vous êtes connecté à Virtuagym à votre entraîneur personnel",
    reportErrorMsg:
      "Vous n avez toujours pas assez de sessions pour voir vos progrès",
    tillen: "Levage",
    duwen: "Pousser",
    zitten: "Séance",
    traplopen: "Marcher les escaliers",
    staan: "Permanent",
    last: "Dernier",
    sessions: "séances",
    all: "Tout",
    motivationMsg0: "Bon travail! Continuez",
    ambition: "",
    question_1_1: "",
    answer_1_1: "",
    question_2_1: "",
    answer_2_1: "",
    question_2_2: "",
    answer_2_2: "",
    question_2_3: "",
    answer_2_3: "",
    question_3_1: "",
    answer_3_1: "",
    question_3_2: "",
    answer_3_2: "",
    question_3_3: "",
    answer_3_3: "",
    question_3_4: "",
    answer_3_4: ``,
    question_3_5: "",
    answer_3_5: "",
  },
  de: {
    welcomeMsg: "Herzlich willkommen",
    bestMachine: "Beste Maschine",
    bestActivity: "Beste Aktivität",
    totalProgress: "GesamtFortschritt",
    average: "Durchschnittlich",
    headerMainMsg: "Sie haben bereits trainiert ",
    times: "mal",
    getraind: "",
    year: "Jahr",
    years: "Jahre",
    and: "und",
    month: "Monat",
    months: "Monate",
    headerMachineMsg:
      "Hier können Sie Verbesserungen an den Maschinen sehen, auf denen Sie wöchentlich trainieren",
    headerActivityMsg:
      "Hier sehen Sie Verbesserungen bei den Aktivitäten, die Sie täglich ausführen",
    totalSessions: "Anzahl der durchgeführten Aktionen",
    bestPerformance: "Beste Leistung",
    date: "Datum",
    score: "Ergebnis",
    weight: "Gewicht",
    duration: "Dauer",
    unknown: "Unbekannt",
    mainErrorMsg: "etwas ist schief gelaufen",
    unknownEmailMsg:
      "Unbekannte Email. Geben Sie Ihre E-Mail-Adresse, mit der Sie bei Virtuagym eingeloggt sind, an Ihren persönlichen Trainer weiter",
    reportErrorMsg:
      "Sie haben immer noch nicht genug Sitzungen, um Ihren Fortschritt zu sehen",
    tillen: "Heben",
    duwen: "Schieben",
    zitten: "Sitzung",
    traplopen: "Gehende Treppe",
    staan: "Stehen",
    last: "Zuletzt",
    sessions: "Sitzungen",
    all: "Alle",
    motivationMsg: "Gut gemacht! Mach weiter",
    ambition: "",
    question_1_1: "",
    answer_1_1: "",
    question_2_1: "",
    answer_2_1: "",
    question_2_2: "",
    answer_2_2: "",
    question_2_3: "",
    answer_2_3: "",
    question_3_1: "",
    answer_3_1: "",
    question_3_2: "",
    answer_3_2: "",
    question_3_3: "",
    answer_3_3: "",
    question_3_4: "",
    answer_3_4: ``,
    question_3_5: "",
    answer_3_5: "",
  },
};

const i18n = new VueI18n({
  locale: "en", // set locale
  fallbackLocale: "en", // set fallback locale
  messages, // set locale messages
});

export default i18n;
